import React from 'react';
import {connect} from 'react-redux';
import ReactECharts from "echarts-for-react";
import PropTypes from "prop-types";
import IndicatorUtils from "../../utils/IndicatorUtils";
import Spinner from "qwc2/components/widgets/Spinner";
import axios from "axios";
import isEmpty from 'lodash.isempty';
import {addLayerFeatures, LayerRole, removeLayer} from "qwc2/actions/layers";
import Moment from "moment";
import TypeUtils from "../../utils/TypeUtils";

class IndicatorDevelopment extends React.Component {
    static propTypes = {
        addLayerFeatures: PropTypes.func,
        removeLayer: PropTypes.func,
        selectedDate: PropTypes.string,
        selectedIndicator: PropTypes.object,
        selectedObjectType: PropTypes.string,
        selectedObjects: PropTypes.array
    }
    static defaultProps = {}

    constructor(props) {
        super(props);

        this.state = {
            data: {},
            isLoading: true,
            url: null,
            selectedData: {}
        };
    }

    updateChart() {
        const url = IndicatorUtils.getDevelopmentUrl(this.props.selectedIndicator, this.props.selectedObjectType);
        const self = this;
        axios(url).then(response => {
            self.setState({
                data: response.data,
                isLoading: false,
                url: url
            });
        }).catch(error => {
            console.log("Error *** : " + error);
        });
    }

    updateSelectedData() {
        if (this.props.selectedObjects) {
            this.props.selectedObjects.forEach(so => {
                const indid = this.props.selectedIndicator.id;
                const objid = so.linkedObject.properties.id;
                if (this.state.selectedData[indid] && this.state.selectedData[indid][objid]) {
                    return;
                }
                const url = IndicatorUtils.getDataUrl(this.props.selectedIndicator, so.linkedObject.properties.objectType, null, [objid]);
                const self = this;
                axios(url).then(response => {
                    const selectedData = this.state.selectedData;
                    if (!selectedData[indid]) {
                        selectedData[indid] = {};
                    }
                    selectedData[indid][objid] = response.data;
                    self.setState({
                        selectedData: selectedData
                    });
                }).catch(error => {
                    console.log("Error *** : " + error);
                });
            });
        }
    }

    componentDidMount() {
        this.updateChart();
        this.updateSelectedData();
    }

    componentDidUpdate() {
        const url = IndicatorUtils.getDevelopmentUrl(this.props.selectedIndicator, this.props.selectedObjectType);
        if (url != this.state.url) {
            this.updateChart();
        }
        this.updateSelectedData();
    }

    render() {
        return (
            <div>
                {this.state.isLoading &&
                    <div>
                        <Spinner/>
                    </div>
                }
                {!this.state.isLoading &&
                    <div>
                        {this.renderChart()}
                    </div>
                }
            </div>
        );
    }

    highlight = (item) => {
        if (item && item.geometry) {
            // copy, the item may belong to the redux state
            const results = [{...item, crs: 'EPSG:4326'}];
            if (!isEmpty(results)) {
                this.props.removeLayer("identifyslection");
                const layer = {
                    id: "identifyslection",
                    role: LayerRole.SELECTION
                };
                this.props.addLayerFeatures(layer, results, true);
            } else {
                this.props.removeLayer("identifyslection");
            }
        }
    }

    renderChart() {
        const dateSortFn = function(a, b) {
            return a[0].valueOf() - b[0].valueOf();
        };

        const minValues = [];
        const maxValues = [];
        const meanValues = [];
        const legend = ['Minimum', 'Mittelwert', 'Maximum'];
        this.state.data.forEach(item => {
            Object.entries(item).forEach(([key, value]) => {
                try {
                    minValues.push([Moment(value.date).toDate(), value.min.toFixed(2)]);
                    maxValues.push([Moment(value.date).toDate(), value.max.toFixed(2)]);
                    meanValues.push([Moment(value.date).toDate(), value.mean.toFixed(2)]);
                } catch (e) {
                    console.log('Could not read min/max/mean values from indicator date: ' + e.message);
                }
            });
        });

        const series = [
            {
                name: 'Minimum',
                data: minValues.sort(dateSortFn),
                smooth: true,
                type: 'line'
            },
            {
                name: 'Mittelwert',
                data: meanValues.sort(dateSortFn),
                smooth: true,
                type: 'line'
            },
            {
                name: 'Maximum',
                data: maxValues.sort(dateSortFn),
                smooth: true,
                type: 'line'
            }
        ];

        if (this.props.selectedObjects) {
            this.props.selectedObjects.forEach(so => {
                const indid = this.props.selectedIndicator.id;
                const objid = so.linkedObject.properties.id;

                if (!this.state.selectedData[indid] || !this.state.selectedData[indid][objid]) {
                    return;
                }

                const values = [];
                const name = so.linkedObject.properties.name || '';
                this.state.selectedData[indid][objid].features.forEach(f => {
                    values.push([Moment(f.properties.date).toDate(), f.properties.value.toFixed(2)]);
                });
                legend.push(name);
                series.push({
                    name: name,
                    data: values.sort(dateSortFn),
                    smooth: true,
                    type: 'line',
                    lineStyle: {
                        type: 'dashed'
                    }
                });
            });
        }

        const options = {
            tooltip: {
                trigger: 'item',
                axisPointer: {
                    type: 'shadow'
                }
            },
            xAxis: {
                type: 'time'
            },
            legend: {
                data: legend
            },
            yAxis: {
                name: this.props.selectedIndicator.unit || '',
                nameLocation: 'middle',
                nameRotate: 90,
                nameGap: 40,
                type: 'value'
            },
            grid: {
                left: 60,
                top: 70
            },
            series: series
        };
        return (
            <ReactECharts
                option={options}
                notMerge={true}
                lazyUpdate={false}
                opts={{locale: 'DE'}}
            />
        );
    }
}

const selector = (state) => ({
    selectedIndicator: state.indicators.selectedIndicator,
    selectedObjects: state.indicators.selectedObjects,
    selectedObjectType: state.indicators.selectedObjectType,
    selectedDate: state.indicators.selectedDate,
});

export default connect(selector, {
    addLayerFeatures: addLayerFeatures,
    removeLayer: removeLayer,
})(IndicatorDevelopment);
